import { createAction, ActionsUnion } from "../definitions";
import { DeviceDefectListActionTypes, TrailerDefectListActionTypes } from "./types";
import { IDefect } from "../../model/Defect";

export interface IDefectListPayload {
    userId: string;
    defectLists?: IIdDictionary<IDefect[]>;
}

/* eslint-disable @typescript-eslint/naming-convention */
export const DeviceDefectListActions = {
    setDeviceDefectLists: (payload: IDefectListPayload) => createAction(DeviceDefectListActionTypes.SET_DEVICE_DEFECTLIST, payload),
    clearDeviceDefectLists: (payload?: IDefectListPayload) => createAction(DeviceDefectListActionTypes.CLEAR_DEVICE_DEFECTLIST, payload)
};

export const TrailerDefectListActions = {
    setTrailerDefectLists: (payload: IDefectListPayload) => createAction(TrailerDefectListActionTypes.SET_TRAILER_DEFECTLIST, payload),
    clearTrailerDefectLists: (payload?: IDefectListPayload) => createAction(TrailerDefectListActionTypes.CLEAR_TRAILER_DEFECTLIST, payload)
};
/* eslint-enable @typescript-eslint/naming-convention */

/* eslint-disable @typescript-eslint/no-redeclare */
export type DeviceDefectListActions = ActionsUnion<typeof DeviceDefectListActions>;
export type TrailerDefectListActions = ActionsUnion<typeof TrailerDefectListActions>;
/* eslint-enable @typescript-eslint/no-redeclare */